module.exports = __webpack_public_path__ + "static/media/shh_jeff.b94423b4.jpg";